import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import '@diekeure/dcr-components/dcr-fab.js';
import '@diekeure/dcr-components/dcr-menu-item.js';
import '@diekeure/dcr-components/dcr-menu.js';

export interface SpeedDialAction {
  label?: string;
  icon?: string;
  primary?: boolean;
  handler: () => void;
}

@Component({
  standalone: false,
  selector: 'campus-speed-dial',
  templateUrl: './speed-dial.component.html',
  styleUrls: ['./speed-dial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpeedDialComponent {
  @HostBinding('class') defaultClasses = ['relative'];
  @Input() speedDialActions: SpeedDialAction[] = [];
  @Input() icon = 'educontent:add';
  @Input() label: string;
  @Input() open: boolean;
  @Output() openChange = new EventEmitter<boolean>();
}
